import React from 'react';
import { CTASection } from '../../components/CTASection';
import { Flag, CheckCircle, Zap, Shield, Sparkles, Clock, DollarSign } from 'lucide-react';
export function Banners() {
  const benefits = [{
    icon: <Sparkles className="w-6 h-6" data-id="element-1112" />,
    title: 'Custom Design Support',
    description: 'Our talented graphic designers bring your vision to life, or upload your own design—we make it uniquely yours'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-1113" />,
    title: 'Built to Last',
    description: 'Premium-grade vinyl banners withstand the elements, keeping your message bright indoors or outdoors'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-1114" />,
    title: 'Lightning-Fast Turnaround',
    description: 'Create your custom banner in minutes and have it shipped as fast as the next day'
  }, {
    icon: <DollarSign className="w-6 h-6" data-id="element-1115" />,
    title: 'Budget-Friendly Quality',
    description: 'The ultimate combo of affordability and durability—quality is our passion, not just a promise'
  }];
  const uses = [{
    icon: '🎤',
    title: 'Event Promotions',
    description: 'Concerts, festivals, fairs, trade shows'
  }, {
    icon: '🎉',
    title: 'Grand Openings',
    description: 'Eye-catching announcements for new businesses'
  }, {
    icon: '💰',
    title: 'Special Sales',
    description: 'Highlight discounts and seasonal promotions'
  }, {
    icon: '🏆',
    title: 'Sports Events',
    description: 'Team spirit and championship celebrations'
  }, {
    icon: '❤️',
    title: 'Fundraisers & Charity',
    description: 'Charity walks, auctions, fundraising galas'
  }, {
    icon: '💍',
    title: 'Weddings & Parties',
    description: 'Receptions, birthdays, graduations, celebrations'
  }, {
    icon: '🏢',
    title: 'Corporate Branding',
    description: 'Logos, slogans, trade shows, conferences'
  }, {
    icon: '🎪',
    title: 'Community Events',
    description: 'Local gatherings, parades, block parties'
  }, {
    icon: '🗳️',
    title: 'Political Campaigns',
    description: 'Show support for candidates or causes'
  }, {
    icon: '🎓',
    title: 'School Events',
    description: 'Pep rallies, graduations, open houses'
  }];
  const features = ['Professional hemming for durability', 'Grommets for easy hanging', 'Indoor and outdoor use', 'Weather-resistant vinyl', 'Full-color printing', 'Custom sizes available', 'Budget-friendly pricing', 'In-house design support'];
  return <div className="flex flex-col w-full" data-id="element-1116">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-wh-teal to-teal-600 py-20" data-id="element-1117">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1118">
          <div className="flex justify-center mb-6" data-id="element-1119">
            <Flag className="w-16 h-16 text-white" data-id="element-1120" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1121">
            Custom Vinyl Banners
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto" data-id="element-1122">
            Create the perfect banner, your way! From business events to
            birthday bashes, we've got high-quality vinyl banners for every
            occasion—all done in-house from start to finish.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white" data-id="element-1123">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1124">
          <div className="max-w-4xl mx-auto mb-16" data-id="element-1125">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-1126">
              Your Vision, Our Expertise
            </h2>
            <div className="prose prose-lg max-w-none text-gray-700 space-y-4" data-id="element-1127">
              <p data-id="element-1128">
                At Wear Haus Designs, everything is done in-house, from start to
                finish! Let our talented graphic designers bring your vision to
                life, or if you already know what you want—just send it our way,
                and we've got you covered! Whether you're adding text, swapping
                out images, or uploading your own masterpiece, we make sure your
                banner is uniquely yours—all while keeping it budget-friendly.
              </p>
              <p data-id="element-1129">
                Our high-quality vinyl banners are the ultimate combo of
                affordability and durability! Whether it's for indoor flair or
                outdoor wow-factor, these premium-grade banners are built to
                withstand the elements, ensuring your message stands tall and
                shines bright wherever it's displayed.
              </p>
            </div>
          </div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-1130">
            {benefits.map((benefit, index) => <div key={index} className="bg-gray-50 rounded-xl p-8 border border-gray-100" data-id="element-1131">
                <div className="flex items-start gap-4" data-id="element-1132">
                  <div className="flex-shrink-0 w-12 h-12 bg-wh-pink rounded-lg flex items-center justify-center text-white" data-id="element-1133">
                    {benefit.icon}
                  </div>
                  <div data-id="element-1134">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-1135">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-1136">{benefit.description}</p>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Features */}
          <div className="bg-gradient-to-br from-wh-teal to-teal-600 rounded-2xl p-12 text-white mb-16" data-id="element-1137">
            <h2 className="text-3xl font-bold mb-8 text-center" data-id="element-1138">
              Why Wear Haus Banners?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl mx-auto" data-id="element-1139">
              {features.map((feature, index) => <div key={index} className="flex items-center gap-3" data-id="element-1140">
                  <CheckCircle className="w-6 h-6 text-wh-yellow flex-shrink-0" data-id="element-1141" />
                  <span className="text-lg" data-id="element-1142">{feature}</span>
                </div>)}
            </div>
          </div>

          {/* Use Cases */}
          <div className="mb-16" data-id="element-1143">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-1144">
              Perfect for Every Occasion
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto" data-id="element-1145">
              Banners make an impactful and professional statement for any
              event. Here are just some of the ways you can use custom vinyl
              banners:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6" data-id="element-1146">
              {uses.map((use, index) => <div key={index} className="bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-wh-teal transition-colors text-center" data-id="element-1147">
                  <div className="text-4xl mb-3" data-id="element-1148">{use.icon}</div>
                  <h3 className="text-lg font-bold text-wh-teal mb-2" data-id="element-1149">
                    {use.title}
                  </h3>
                  <p className="text-sm text-gray-600" data-id="element-1150">{use.description}</p>
                </div>)}
            </div>
          </div>

          {/* Process */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-1151">
            <div className="bg-white rounded-xl p-8 border-2 border-wh-pink text-center" data-id="element-1152">
              <div className="w-16 h-16 bg-wh-pink rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4" data-id="element-1153">
                1
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1154">
                Design Your Banner
              </h3>
              <p className="text-gray-700" data-id="element-1155">
                Work with our designers or upload your own artwork—we make it
                easy and budget-friendly
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-wh-teal text-center" data-id="element-1156">
              <div className="w-16 h-16 bg-wh-teal rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4" data-id="element-1157">
                2
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1158">
                We Print & Finish
              </h3>
              <p className="text-gray-700" data-id="element-1159">
                High-quality vinyl printing with professional hemming and
                grommets
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 border-2 border-wh-yellow text-center" data-id="element-1160">
              <div className="w-16 h-16 bg-wh-yellow rounded-full flex items-center justify-center text-gray-900 text-2xl font-bold mx-auto mb-4" data-id="element-1161">
                3
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-1162">
                Fast Shipping
              </h3>
              <p className="text-gray-700" data-id="element-1163">
                Lightning-fast turnaround—shipped as fast as the next day!
              </p>
            </div>
          </div>

          {/* Rush Service Highlight */}
          <div className="bg-gradient-to-br from-wh-yellow to-yellow-500 rounded-2xl p-12 mb-16" data-id="element-1164">
            <div className="max-w-3xl mx-auto text-center" data-id="element-1165">
              <Zap className="w-16 h-16 mx-auto mb-6 text-gray-900" data-id="element-1166" />
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-1167">
                Need It Fast? We've Got You!
              </h2>
              <p className="text-xl text-gray-800 mb-6" data-id="element-1168">
                In a rush? No worries! Our super-quick turnaround means you can
                whip up a custom banner in minutes and have it shipped out as
                fast as the next day! Perfect for those last-minute events or
                spontaneous celebrations.
              </p>
              <p className="text-lg text-gray-700" data-id="element-1169">
                From concept to delivery, we move at your speed without
                compromising on quality.
              </p>
            </div>
          </div>

          {/* CTA Box */}
          <div className="bg-gradient-to-br from-wh-pink to-pink-600 rounded-2xl p-12 text-center text-white" data-id="element-1170">
            <Flag className="w-16 h-16 mx-auto mb-6" data-id="element-1171" />
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-1172">
              Ready to Make Your Statement?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-1173">
              From business events to birthday bashes, let's create a banner
              that stands tall and shines bright. Quality isn't just a
              promise—it's our passion!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1174">
              <a href="/contact" className="inline-flex items-center justify-center px-8 py-4 bg-white text-wh-pink font-bold rounded-lg hover:bg-gray-100 transition-colors" data-id="element-1175">
                Get a Quote
              </a>
              <a href="/services" className="inline-flex items-center justify-center px-8 py-4 bg-wh-yellow text-gray-900 font-bold rounded-lg hover:bg-yellow-400 transition-colors" data-id="element-1176">
                View All Services
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection data-id="element-1177" />
    </div>;
}